import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

import request from '@/utils/request.js'






const store = new Vuex.Store({
	state: {
		userInfo: null,
		config: {},
		localHouseInfo: null,
		sm: window.innerWidth < 992,
	},
	mutations: {

		setSm(state) {
			state.sm = window.innerWidth < 992;
		},

		setLogin(state, {
			token,
			userId,
			userInfo,
		}) {
			state.userInfo = userInfo;
			localStorage.setItem('token', token)
			localStorage.setItem('userId', userId)
			localStorage.setItem('userInfo', userInfo)


		},
		setLogout(state) {
			state.userInfo = null;
			localStorage.removeItem('token');
			localStorage.removeItem('userId');
		},

		setLocalHouseInfo(state, localHouseInfo) {
			state.localHouseInfo = localHouseInfo;
		},


	},
	actions: {
		initLogin({
			commit,
			state
		}, {
			success,
			fail,
			cb
		}) {
			request({
				url: '/api/login/info',
				data: {},
				success: resp => {
					commit('setLogin', resp.data);

					cb && cb();
				}
			})
		},
		initConfig({
			commit,
			state
		}, {
			success,
			fail
		}) {
			request({
				url: '/api/config',
				success: resp => {
					state.config = {
						...state.config,
						...resp.data
					}
					success && success(state.config);
				},
				fail: () => {
					fail && fail()
				},
			})
		},

	}
});
export default store;